const SITE_URL: string = import.meta.env.VITE_SITE_URL || 'https://basetaosheet.courses';
const SITE_NAME = 'BaseTao Spreadsheet Courses';
const SITE_DESCRIPTION =
  'Master BaseTao Spreadsheet with expert tutorials, reviews, shipping cost guides, coupon codes, and comprehensive resources for every skill level.';
const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png';

export { SITE_URL, SITE_NAME, SITE_DESCRIPTION, FAVICON_URL };

export interface PageSeoInput {
  headline: string;
  description: string;
  path: string;
}

export function buildOrganizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: `${SITE_URL}/`,
    logo: FAVICON_URL,
  };
}

export function buildWebSiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: `${SITE_URL}/`,
    description: SITE_DESCRIPTION,
  };
}

export function buildArticleJsonLd({ headline, description, path }: PageSeoInput) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}${path}`,
    },
    author: {
      '@type': 'Organization',
      name: 'BaseTao Spreadsheet Editorial Team',
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
    datePublished: '2026-08-01',
    dateModified: '2026-08-18',
  };
}

export function buildWebPageJsonLd({ headline, description, path }: PageSeoInput) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: headline,
    description,
    url: `${SITE_URL}${path}`,
    inLanguage: 'en',
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: `${SITE_URL}/`,
    },
  };
}